module.exports = __webpack_public_path__ + "static/media/sf-trial-2.bf8996bf.mp3";